import { dtRum } from './dtRum';
/**
 * Função responsável por gravar alguma ação, em algum ponto especifico do código
 *
 * @param string description
 * @returns void
 */
export function dynatraceCustomTrack(description) {
    if (!dtRum)
        return;
    var actionNameDescription = "Custom track - ".concat(description);
    var customAction = dtRum.enterAction(actionNameDescription);
    dtRum.leaveAction(customAction);
}
//# sourceMappingURL=dynatraceCustomTrack.js.map